// extracted by mini-css-extract-plugin
export default {"root":"InstanceConfigModal_root__yYMd8","container":"InstanceConfigModal_container__12YLu"};